import React from 'react';
import { Snowflake, Mail, Phone, MapPin, Clock } from 'lucide-react';

export const BrandMark = ({ size = 'lg', showAddress = true }) => {
  const isXL = size === 'xl';
  const isSM = size === 'sm';
  const flakeClass = isXL
    ? 'w-9 h-9 text-blue-400'
    : isSM
      ? 'w-5 h-5 text-blue-400'
      : 'w-7 h-7 text-blue-400';
  const nameClass = isXL
    ? 'text-6xl sm:text-7xl'
    : isSM
      ? 'text-xl'
      : 'text-4xl sm:text-5xl';
  const txtClass = isXL ? 'text-sm sm:text-base' : isSM ? 'text-xs' : 'text-sm';

  return (
    <div
      className="flex flex-col items-center text-center select-none"
      data-testid="brand-mark"
    >
      <div className="flex items-center gap-3 mb-2">
        <Snowflake className={flakeClass} strokeWidth={1.2} />
        <span className={`font-display font-light tracking-[0.18em] shimmer-text ${nameClass}`}>
          KRYOTEKS
        </span>
        <Snowflake className={flakeClass} strokeWidth={1.2} />
      </div>

      {showAddress && (
        <div className={`text-slate-300 font-body tracking-wide ${txtClass}`} data-testid="brand-contact">
          <p className="inline-flex items-center gap-1.5">
            <MapPin className="w-3.5 h-3.5 text-blue-400/80 shrink-0" strokeWidth={1.6} />
            <span data-testid="brand-address">2500 Polk St., San Francisco, CA 94109</span>
          </p>
          <p className="mt-1.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-blue-300">
            <a
              href="tel:+15108271848"
              className="inline-flex items-center gap-1.5 hover:text-blue-200 transition-colors"
              data-testid="brand-phone"
            >
              <Phone className="w-3.5 h-3.5 shrink-0" strokeWidth={1.6} />
              510-827-1848
            </a>
            <a
              href="mailto:kryoteks@gmail.com"
              className="inline-flex items-center gap-1.5 hover:text-blue-200 transition-colors"
              data-testid="brand-email"
            >
              <Mail className="w-3.5 h-3.5 shrink-0" strokeWidth={1.6} />
              kryoteks@gmail.com
            </a>
          </p>
          <p className="mt-2 flex justify-center">
            <span
              className="inline-flex items-center gap-1.5 rounded-full border border-blue-400/40 bg-blue-500/10 text-blue-200 px-3 py-1 text-[11px] tracking-[0.2em] uppercase font-bold"
              data-testid="brand-appointment-only"
            >
              <Clock className="w-3 h-3" strokeWidth={2} />
              By Appointment Only
            </span>
          </p>
        </div>
      )}
    </div>
  );
};

export default BrandMark;
